const errorMessageStyles = () => ({
  message: {
    width: 310,
    overflowWrap: "break-word",
  },
  "@media (min-width: 1280px)": {
    message: {
      width: 330,
    },
  },
});

export default errorMessageStyles;
